export const UserReviews = [
  {
    name: "Alexis",
    date: "January 5, 2023",
    text: "Booked a space for my photoshoot, and it was exactly what I needed. Great lighting and ambience!",
    id: "1",
    rating: 5,
  },
  {
    name: "Jordan",
    date: "February 18, 2023",
    text: "Such a smooth experience! Found a great spot for content creation. Will book again soon.",
    id: "2",
    rating: 2,
  },
  {
    name: "Taylor",
    date: "March 10, 2023",
    text: "This platform makes finding creative spaces so easy. The location was perfect for my video shoot.",
    id: "3",
    rating: 3,
  },
  {
    name: "Morgan",
    date: "April 5, 2023",
    text: "The space exceeded my expectations! Loved the vibe, and my team got some amazing shots.",
    id: "4",
    rating: 3,
  },
  {
    name: "Chris",
    date: "May 22, 2023",
    text: "Such an awesome idea! I found a fully decorated space that made my shoot so much easier.",
    id: "5",
    rating: 5,
  },
  {
    name: "Jamie",
    date: "June 14, 2023",
    text: "Great platform! The spot I booked was perfect for content creation, and the host was super helpful.",
    id: "6",
    rating: 5,
  },
  {
    name: "Sam",
    date: "July 9, 2023",
    text: "Booked a space for a last-minute shoot and it worked out perfectly. Highly recommend!",
    id: "7",
    rating: 5,
  },
  {
    name: "Riley",
    date: "August 1, 2023",
    text: "Had a fantastic experience! The space was exactly as described and worked great for my project.",
    id: "8",
    rating: 5,
  },
  {
    name: "Casey",
    date: "August 28, 2023",
    text: "I was able to find the perfect spot for my short film. This platform is a game changer!",
    id: "9",
    rating: 2,
  },
  {
    name: "Drew",
    date: "September 7, 2023",
    text: "The setup was perfect for our team's creative brainstorming session. Can't wait to book again.",
    id: "10",
    rating: 3,
  },
  {
    name: "Parker",
    date: "September 21, 2023",
    text: "Loved the versatility of the space we booked! It was just right for our multi-day shoot.",
    id: "11",
    rating: 4,
  },
  {
    name: "Cameron",
    date: "October 2, 2023",
    text: "Not good",
    id: "12",
    rating: 1,
  },
  {
    name: "Devin",
    date: "October 15, 2023",
    text: "The space was incredible, well-maintained, and the perfect backdrop for my content creation.",
    id: "13",
    rating: 4,
  },
  {
    name: "Sydney",
    date: "October 30, 2023",
    text: "This platform made it so easy to find a creative space! Perfect for my Instagram shoot.",
    id: "14",
    rating: 2,
  },
  {
    name: "Rowan",
    date: "November 12, 2023",
    text: "Super convenient to book and the space had everything I needed for my content day!",
    id: "15",
    rating: 4,
  },
  {
    name: "Jesse",
    date: "November 28, 2023",
    text: "Great experience overall. Found a unique spot that worked perfectly for my brand's video shoot.",
    id: "16",
    rating: 5,
  },
  {
    name: "Hunter",
    date: "December 5, 2023",
    text: "Booking a space was a breeze! The setup was ideal for my interview series. Highly recommend.",
    id: "17",
    rating: 4,
  },
  {
    name: "Shawn",
    date: "December 15, 2023",
    text: "The space had great natural light, which was a huge plus for my photography session. Will be back!",
    id: "18",
    rating: 4,
  },
  {
    name: "Taylor",
    date: "January 3, 2024",
    text: "Loved the location and the whole experience. Found a creative space that truly fit my needs.",
    id: "19",
    rating: 3,
  },
  {
    name: "Dakota",
    date: "January 10, 2024",
    text: "The space I booked was spacious and well-decorated. Perfect for shooting content. Great find!",
    id: "20",
    rating: 5,
  },
  {
    name: "Toni",
    date: "January 22, 2024",
    text: "This platform is amazing! Found a fully equipped space, and it made my content creation so much easier.",
    id: "21",
    rating: 4,
  },
];
